import { html } from 'lit';
import { UserCog } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-user-cog')
export class PdsIconUserCog extends PdsIcon {
  @state()
  icon = UserCog;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
